import {
  AllCarsMotors64,
  Cars64,
  CarsFromDealerships64,
  NewCars64,
  Commercials64,
  PlantMachinery64,
  VintageCars64,
  Motorbikes64,
  DamagedCars64,
  MotorbikeExtras64,
  Boats64,
  BoatExtras64,
  Campers64,
  Caravans64,
  CarExtras64,
  CarParts64,
  CoachesBuses64,
  ModifiedCars64,
  OtherMotors64,
  Quads64,
  RallyCars64,
  Scooters64,
  Trailers64,
  Trucks64,
  VintageBikes64,
} from '../../../components/Toolkit/Base64/Sections';

export interface Map {
  [name: string]: JSX.Element;
}

const MotorsIcons: Map = {
  cars: <Cars64 alt="" />,
  carsfromdealerships: <CarsFromDealerships64 alt="" />,
  'new-cars': <NewCars64 alt="" />,
  commercials: <Commercials64 alt="" />,
  plantmachinery: <PlantMachinery64 alt="" />,
  vintagecars: <VintageCars64 alt="" />,
  motorbikes: <Motorbikes64 alt="" />,
  damagedcars: <DamagedCars64 alt="" />,
  boats: <Boats64 alt="" />,
  boatextras: <BoatExtras64 alt="" />,
  campers: <Campers64 alt="" />,
  caravans: <Caravans64 alt="" />,
  carextras: <CarExtras64 alt="" />,
  carparts: <CarParts64 alt="" />,
  coaches: <CoachesBuses64 alt="" />,
  modifiedcars: <ModifiedCars64 alt="" />,
  motorbikeextras: <MotorbikeExtras64 alt="" />,
  othermotor: <OtherMotors64 alt="" />,
  quads: <Quads64 alt="" />,
  rallycars: <RallyCars64 alt="" />,
  scooters: <Scooters64 alt="" />,
  trailers: <Trailers64 alt="" />,
  trucks: <Trucks64 alt="" />,
  vintagebikes: <VintageBikes64 alt="" />,
  motor: <AllCarsMotors64 alt="" />,
};

export default MotorsIcons;
